import { concatClasses } from "../../../helpers/concatClasses/index.js";
const sizeClassMap = {
  small: "h-12 w-12",
  medium: "h-16 w-16",
  large: "h-20 w-20"
};
const getCheckmarkBackgroundClasses = ({ dsf_checked, disabled, dsf_indeterminate }) => {
  if (disabled) {
    return `bg-neutral-100`;
  }
  const classes = [];
  const focusedClasses = ["focus:border-secondary-300", "focus-visible:shadow-focus-secondary-sm"];
  if (dsf_checked || dsf_indeterminate) {
    classes.push("bg-secondary-300", "hover:bg-secondary-400", ...focusedClasses);
  } else {
    classes.push("bg-neutral-0", "border", "border-neutral-200", ...focusedClasses);
  }
  return concatClasses(classes);
};
const sizeToCheckmarkIconSize = {
  medium: "after:left-5 after:w-5 after:h-10",
  small: "after:left-4 after:w-4 after:h-8",
  large: "after:left-[calc(0.625*var(--dsf-base-size))] after:w-[calc(0.625*var(--dsf-base-size))] after:h-12"
};
const getCheckmarkAfterElementClasses = ({
  dsf_indeterminate,
  dsf_checked,
  disabled
}) => {
  const classes = ["after:border-r-1", "after:transform", "after:absolute", "after:content-['']"];
  if (disabled) {
    classes.push("after:border-neutral-300");
  } else {
    classes.push("after:border-neutral-0");
  }
  if (dsf_indeterminate && !dsf_checked) {
    classes.push("after:rotate-90");
  } else {
    classes.push("after:border-b-1", "after:rotate-45");
  }
  return concatClasses(classes);
};
const getInputClasses = (props) => {
  const classes = [
    "absolute",
    "top-0",
    "left-0",
    "bottom-0",
    "m-auto",
    "rounded-xs",
    "appearance-none",
    "outline-none"
  ];
  const visibilityClass = props.dsf_checked || props.dsf_indeterminate ? "after:block" : "after:hidden";
  const backgroundClass = getCheckmarkBackgroundClasses(props);
  if (props.disabled) {
    classes.push("cursor-not-allowed", "select-none");
  } else {
    classes.push("cursor-pointer");
  }
  const checkmarkIconSize = sizeToCheckmarkIconSize[props.dsf_size];
  const alignClassForCheckmarkIcon = sizeToAlignClass[props.dsf_size];
  const checkmarkAfterElementClass = getCheckmarkAfterElementClasses(props);
  const checkmarkStyles = `${checkmarkIconSize} ${checkmarkAfterElementClass}`;
  return concatClasses([
    ...classes,
    backgroundClass,
    sizeClassMap[props.dsf_size],
    checkmarkStyles,
    visibilityClass,
    alignClassForCheckmarkIcon
  ]);
};
const paddingToSizeMap = {
  small: "pl-20",
  medium: "pl-24",
  large: "pl-28"
};
const getContainerClasses = (props) => {
  const classes = [
    "dsf-text-s",
    "text-neutral-700",
    "relative",
    "flex",
    "items-center",
    paddingToSizeMap[props.dsf_size]
  ];
  if (props.disabled) {
    classes.push("cursor-not-allowed", "select-none");
  } else {
    classes.push("cursor-pointer");
  }
  return concatClasses(classes);
};
const sizeToTextClassMap = {
  small: "dsf-text-xxs",
  medium: "dsf-text-xs",
  large: "dsf-text-s"
};
const sizeToAlignClass = {
  small: "after:mt-[calc(0.05*var(--dsf-base-size))]",
  medium: "after:mt-[calc(0.075*var(--dsf-base-size))]",
  large: "after:mt-1"
};
const getTextLabelClasses = (size) => {
  return sizeToTextClassMap[size];
};
export {
  getCheckmarkAfterElementClasses,
  getContainerClasses,
  getInputClasses,
  getTextLabelClasses
};
